var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import useResumableFilesUpload from '../../../../helpers/hooks/useResumableFilesUpload';
import sendAPIRequest from '../../../../helpers/api/plugNmeetAPI';
import { updateShowExternalMediaPlayerModal } from '../../../../store/slices/bottomIconsActivitySlice';
import { useAppDispatch } from '../../../../store';
import { CommonResponse, ExternalMediaPlayerReq, ExternalMediaPlayerTask, } from '../../../../helpers/proto/plugnmeet_common_api_pb';
const Upload = () => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [files, setFiles] = useState();
    const [tmpFiles, setTmpFiles] = useState();
    const allowedFileTypes = ['mp4', 'mp3', 'webm'];
    const { isUploading, result } = useResumableFilesUpload({
        allowedFileTypes: allowedFileTypes,
        maxFileSize: undefined,
        files,
    });
    useEffect(() => {
        const sendPlaybackLink = async (playBackUrl) => {
            const id = toast.loading(t('footer.notice.external-media-player-starting'), {
                type: 'info',
            });
            const body = new ExternalMediaPlayerReq({
                task: ExternalMediaPlayerTask.START_PLAYBACK,
                url: playBackUrl,
            });
            const r = await sendAPIRequest('externalMediaPlayer', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
            const res = CommonResponse.fromBinary(new Uint8Array(r));
            if (!res.status) {
                toast.update(id, {
                    render: t(res.msg),
                    type: 'error',
                    isLoading: false,
                    autoClose: 1000,
                });
            }
            toast.dismiss(id);
            dispatch(updateShowExternalMediaPlayerModal(false));
        };
        if (result && result.filePath) {
            const playback = window.PLUG_N_MEET_SERVER_URL +
                '/download/uploadedFile/' +
                result.filePath;
            sendPlaybackLink(playback);
        }
    }, [result]);
    const upload = () => {
        if (!isUploading && tmpFiles) {
            setFiles([...tmpFiles]);
        }
    };
    const onChange = (e) => {
        const files = e.target.files;
        if (!files.length) {
            return;
        }
        setTmpFiles([...files]);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "ex-m-p-file-upload relative h-[80px] mt-[10px] mb-[50px]", children: [_jsx("div", { className: "absolute -bottom-[30px] dark:text-darkText", children: t('footer.modal.external-media-player-upload-supported-files', {
                            files: allowedFileTypes.map((type) => '.' + type).join(', '),
                        }) }), _jsx("input", { type: "file", id: "chat-file", accept: allowedFileTypes.map((type) => '.' + type).join(','), onChange: (e) => onChange(e), className: "absolute left-0 w-full h-full top-0 py-[28px] px-5 border border-dashed border-primaryColor dark:border-darkText dark:text-darkText cursor-pointer rounded" })] }), _jsx("div", { className: "pb-3 pt-4 bg-gray-50 dark:bg-transparent text-right mt-4", children: _jsx("button", { className: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primaryColor hover:bg-secondaryColor focus:outline-none focus:ring-2 focus:ring-offset-2 focus:bg-secondaryColor", disabled: isUploading, onClick: () => upload(), children: t('footer.modal.external-media-player-upload-file-play') }) })] }));
};
_react_refresh_temp_1 = Upload;
$RefreshReg$(_react_refresh_temp_1, "Upload");
_react_refresh_temp_2(Upload, "S4TK3PujgwanUZDJrNuKTRATbJo=", false, () => [useTranslation, useAppDispatch, useResumableFilesUpload]);
export default Upload;
